module.exports = __webpack_public_path__ + "img/67.7883ab03.png";